export default () => {
  window.addEventListener("load", () => {
    document.body.classList.add("js-loaded");
  });

  //Lettura viewport
  let vw = document.body.clientWidth * 0.01;
  let vh = window.screen.availHeight * 0.01;
  document.documentElement.style.setProperty("--vw", `${vw}px`);
  document.documentElement.style.setProperty("--vh", `${vh}px`);

  const is_touch_enabled = () => {
    return (
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    );
  };

  if (!is_touch_enabled()) {
    document.body.classList.toggle("is-not-touchable");
  }

  window.addEventListener("resize", () => {
    // We execute the same script as before
    vw = document.body.clientWidth * 0.01;
    document.documentElement.style.setProperty("--vw", `${vw}px`);
    vh = window.screen.availHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  });

  let scrollPos =
    window.scrollY ||
    window.scrollTop ||
    document.getElementsByTagName("html")[0].scrollTop;
  const checkScrollPosition = (scrollPos) => {
    if (scrollPos >= 50) {
      document.querySelector("body").classList.add("is-scrolled");
      document.querySelector("body").classList.remove("is-top");
    } else {
      document.querySelector("body").classList.remove("is-scrolled");
      document.querySelector("body").classList.add("is-top");
    }
  };

  checkScrollPosition(scrollPos);
  document.addEventListener("scroll", () => {
    scrollPos =
      window.scrollY ||
      window.scrollTop ||
      document.getElementsByTagName("html")[0].scrollTop;
    checkScrollPosition(scrollPos);
  });
};
